"use client";

import { createContext, useContext, type RefObject } from "react";

export type DriverAvailabilityCategory = "Passenger" | "Goods";

export type DriverAvailabilitySession = {
  userId: number;
  category: DriverAvailabilityCategory;
  token: string;
};

export type HomepageDriverSessionController = {
  userId: number | null;
  sessionRef: RefObject<DriverAvailabilitySession | null>;
};

export const HomepageDriverSessionContext =
  createContext<HomepageDriverSessionController | null>(null);

export function useHomepageDriverSession() {
  return useContext(HomepageDriverSessionContext);
}
